import type { CaseRole } from './cases'
import { apiClient } from './client'
import { humintPath } from './humint-path'
import type { CaptureStateDto, VoiceQualityDto } from './humint-subject-page'
import type { RecordingVoiceMatchSummary } from './recording-voice-matches'

export interface IdentityAudioRecord {
  document_id: string
  title: string
  capture_id: string | null
  kind: 'voice_sample' | 'recording'
  recorded_at: string
  imported: boolean
  state: CaptureStateDto
  audio_url: string
  voices: number[]
  voice_quality: VoiceQualityDto | null
  matches: RecordingVoiceMatchSummary[]
}

export interface IdentityAudioResponse {
  view_id: string
  items: IdentityAudioRecord[]
  member_role: CaseRole
}

export const identityAudioApi = {
  read: async (caseId: string, subjectRef: string, signal?: AbortSignal) => {
    const response = await apiClient.get<IdentityAudioResponse>(
      humintPath(caseId, 'subjects', subjectRef, 'audio'),
      {
        signal,
      }
    )
    return {
      ...response,
      items: response.items.map(row => ({ ...row, matches: row.matches ?? [] })),
    }
  },
}
